import { Translate } from '@components'
import { Modal, ModalBody, ModalFooter, ModalProps } from '@components-deprecated'

import { Button, Checkbox, Link, Space, Text } from '@billy/design-system'
import React, { ChangeEvent, ReactElement, useCallback, useEffect, useState } from 'react'
import { Trans } from 'react-i18next'

import * as Styled from './styles'

export interface SalarySignupConfirmationModalProps extends ModalProps {
  onCancel: () => void
  onConfirm: () => void
}

export const SalarySignupConfirmationModal = ({
  onClose,
  onCancel,
  onConfirm,
  isOpen,
  ...rest
}: SalarySignupConfirmationModalProps): ReactElement => {
  const [areTermsAccepted, setAreTermsAccepted] = useState(false)

  useEffect(() => {
    if (!isOpen) {
      setAreTermsAccepted(false)
    }
  }, [isOpen])

  const handleTermsCheckboxChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setAreTermsAccepted(event.currentTarget.checked)
  }, [])

  return (
    <Modal onClose={onClose || onCancel} isOpen={isOpen} {...rest}>
      <ModalBody>
        <Styled.LogoWrapper>
          <Styled.Logo logo="salary" />
        </Styled.LogoWrapper>

        <Text variant="h4">
          <Translate value="salary.signup.modal.how_it_works.title" />
        </Text>
        <Space size="s16" />

        <Text colorVariant="secondary">
          <Translate value="salary.signup.modal.how_it_works.description1" />
        </Text>
        <Space size="s24" />

        <Text colorVariant="secondary">
          <Translate value="salary.signup.modal.how_it_works.description2" />
        </Text>
        <Space size="s24" />

        <Text colorVariant="secondary">
          <Translate value="salary.signup.modal.how_it_works.description3" />
        </Text>
        <Space size="s24" />

        <Text variant="h4">
          <Translate value="salary.signup.modal.price.title" />
        </Text>
        <Space size="s16" />

        <Text colorVariant="secondary">
          <Translate value="salary.signup.modal.price.description" />
        </Text>
        <Space size="s24" />
      </ModalBody>

      <ModalFooter>
        <Styled.TermsWrapper>
          <Checkbox checked={areTermsAccepted} onChange={handleTermsCheckboxChange}>
            <Trans i18nKey="salary.signup.modal.terms">
              I accept
              <Link href="https://app.salary.dk/terms" target="_blank" underlined>
                the terms
              </Link>
            </Trans>
          </Checkbox>
        </Styled.TermsWrapper>
        <Button onClick={onConfirm} disabled={!areTermsAccepted}>
          <Translate value="salary.signup.modal.submit" />
        </Button>
      </ModalFooter>
    </Modal>
  )
}
